module.exports = __webpack_public_path__ + "img/星链C2M赋能鞋业突围.6cfcb8d6.png";